import api from '@/utils/api';

/**
 * Update Customer
 * @param {string} id Customer id
 * @param {object} customerData - The Customer data
 * @returns {Promise}
 */
const updateCustomerApi = (id, customerData) =>
  api.patch(`/customer/${id}`, customerData);

export default updateCustomerApi;
